module.exports = __webpack_public_path__ + "img/大雾.405b3886.png";